var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilitySferics01 = function SvgProbabilitySferics01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 701.97 559.99",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-18);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.04,
    y1: 296.01,
    x2: 509.04,
    y2: -98.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.85,
    y1: 363.04,
    x2: 562.85,
    y2: -31.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -30.6,
    y1: 236.68,
    x2: 461.4,
    y2: -158.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 238.8,
    y1: 572.23,
    x2: 730.8,
    y2: 177.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 216.61,
    y1: 544.59,
    x2: 708.61,
    y2: 149.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 307.78,
    y1: 658.15,
    x2: 799.78,
    y2: 263.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 260.99,
    y1: 599.87,
    x2: 752.99,
    y2: 204.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 160.75,
    y1: 475.01,
    x2: 652.75,
    y2: 80.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 209.05,
    y1: 535.18,
    x2: 701.05,
    y2: 140.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 231.24,
    y1: 562.82,
    x2: 723.24,
    y2: 167.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 164.62,
    y1: 479.83,
    x2: 656.62,
    y2: 84.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 186.86,
    y1: 507.54,
    x2: 678.86,
    y2: 112.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 352.16,
    y1: 713.43,
    x2: 844.16,
    y2: 318.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 281.63,
    y1: 625.58,
    x2: 773.63,
    y2: 230.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 239.33,
    y1: 572.89,
    x2: 731.33,
    y2: 177.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 322.41,
    y1: 676.38,
    x2: 814.41,
    y2: 281.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 280.48,
    y1: 624.15,
    x2: 772.48,
    y2: 229.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 156.94,
    y1: 470.27,
    x2: 648.94,
    y2: 75.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 300.22,
    y1: 648.74,
    x2: 792.22,
    y2: 253.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 329.97,
    y1: 685.79,
    x2: 821.97,
    y2: 290.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 239.7,
    y1: 573.35,
    x2: 731.7,
    y2: 178.35,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M171.78,0C76.91,0,0,76.91,0,171.78s76.91,171.78,171.78,171.78,171.78-76.91,171.78-171.78S266.65,0,171.78,0ZM75.39,143.18c-4.1-6.8-6.15-14.4-6.15-22.8s2.07-16.3,6.23-23.1c4.15-6.8,9.65-12.15,16.5-16.05,6.85-3.9,14.32-5.85,22.42-5.85s15.7,2,22.5,6c6.8,4,12.23,9.4,16.27,16.2,4.05,6.8,6.08,14.4,6.08,22.8s-2.08,16.15-6.23,22.95c-4.15,6.8-9.63,12.15-16.42,16.05-6.8,3.9-14.2,5.85-22.2,5.85s-15.73-1.97-22.57-5.92c-6.85-3.95-12.33-9.32-16.43-16.13ZM130.89,284.18h-42.3l121.2-210h42.3l-121.2,210ZM265.36,260.78c-4.05,6.8-9.5,12.23-16.35,16.28-6.85,4.05-14.43,6.08-22.73,6.08s-15.85-2.07-22.65-6.23c-6.8-4.15-12.2-9.65-16.2-16.5-4-6.85-6-14.22-6-22.12,0-8.6,2.07-16.3,6.22-23.1,4.15-6.8,9.65-12.17,16.5-16.12,6.85-3.95,14.22-5.92,22.12-5.92,8.6,0,16.3,2.1,23.1,6.3,6.8,4.2,12.17,9.73,16.12,16.58,3.95,6.85,5.93,14.28,5.93,22.27s-2.03,15.7-6.08,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.29,218.18c-5.4,0-10.05,1.95-13.95,5.85-3.9,3.9-5.85,8.65-5.85,14.25s1.95,10.05,5.85,13.95c3.9,3.9,8.55,5.85,13.95,5.85s10.35-1.95,14.25-5.85c3.9-3.9,5.85-8.55,5.85-13.95s-1.95-10.35-5.85-14.25c-3.9-3.9-8.65-5.85-14.25-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.39,140.18c5.4,0,10.05-1.92,13.95-5.77,3.9-3.85,5.85-8.52,5.85-14.02s-1.95-10.3-5.85-14.1c-3.9-3.8-8.55-5.7-13.95-5.7s-10.23,1.9-14.17,5.7c-3.95,3.8-5.93,8.5-5.93,14.1s1.97,10.18,5.93,14.02c3.95,3.85,8.67,5.77,14.17,5.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.59,515.9h0c-3.83-2.21-8.72-.9-10.93,2.93l-16.83,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.76,0,5.45-1.43,6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.97,515.9h0c-3.83-2.21-8.72-.9-10.93,2.93l-16.84,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.63,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M470.59,515.9h0c-3.83-2.21-8.72-.9-10.93,2.93l-16.84,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M351.21,515.9h0c-3.82-2.21-8.72-.9-10.93,2.93l-16.84,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.76,0,5.45-1.43,6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.37,235.26c6.95,2.36,13.48,6.12,19.02,11.14,2.26,2.05,5.48,2.64,8.32,1.52,2.83-1.12,4.79-3.75,5.04-6.79,3.61-44.21,42.54-77.62,86.79-74.5,44.24,3.13,78.09,41.69,75.44,85.97-.13,2.2.65,4.36,2.16,5.96,1.51,1.61,3.62,2.52,5.82,2.52,7.05,0,14.05.97,20.79,2.88,4.25,1.2,8.67-1.26,9.88-5.51,1.2-4.25-1.27-8.67-5.52-9.88-5.55-1.57-11.25-2.62-17.01-3.13-.51-22.82-8.93-44.54-24.15-61.88-17.01-19.39-40.55-31.07-66.29-32.89-25.73-1.82-50.68,6.43-70.25,23.23-16.06,13.79-26.98,32.03-31.54,52.34-4.16-2.46-8.56-4.46-13.1-6.02-1.6,5.1-3.4,10.11-5.38,15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M279.81,462.78h0l-12.98,22.48c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93-3.83-2.21-8.72-.9-10.93,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.42,462.78h0l-12.98,22.48c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.63,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93-3.83-2.21-8.72-.9-10.93,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M266.13,430.63h0s74.95,0,74.95,0c4.42,0,8-3.58,8-8s-3.58-8-8-8h-74.89c-29.24-.23-53.03-24.21-53.03-53.45,0-2.34.17-4.65.47-6.92-5.38,1.78-10.85,3.33-16.41,4.67-.02.75-.05,1.5-.05,2.25,0,38,30.91,69.15,68.97,69.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.19,462.78h0l-12.98,22.48c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.63,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93-3.83-2.21-8.72-.9-10.93,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.82,515.9h0c-3.83-2.21-8.72-.9-10.93,2.93l-16.84,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l16.83-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M637.1,339.01v-54.46c0-4.42-3.58-8-8-8s-8,3.58-8,8v54.46c-15.7,3.64-27.44,17.73-27.44,34.52,0,19.54,15.9,35.44,35.44,35.44s35.44-15.9,35.44-35.44h0c0-16.79-11.74-30.88-27.44-34.52ZM629.1,392.97c-10.72,0-19.44-8.72-19.44-19.44s8.72-19.44,19.44-19.44,19.44,8.72,19.44,19.44-8.72,19.44-19.44,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.68,320.13V116.56c0-27.34-22.24-49.58-49.58-49.58s-49.58,22.24-49.58,49.58v203.57c-14.85,13.78-23.29,33.03-23.29,53.39,0,40.18,32.69,72.86,72.86,72.86s72.86-32.69,72.86-72.86h0c0-20.36-8.44-39.61-23.29-53.39ZM595.52,116.56c0-18.52,15.06-33.58,33.58-33.58s33.58,15.06,33.58,33.58v6.13h-67.16v-6.13ZM685.97,373.53c0,31.35-25.51,56.86-56.86,56.86s-56.86-25.51-56.86-56.86c0-16.89,7.44-32.8,20.42-43.65,1.82-1.52,2.87-3.77,2.87-6.14v-185.05h67.16v17.68h-9.88c-4.42,0-8,3.58-8,8s3.58,8,8,8h9.88v23.92h-9.88c-4.42,0-8,3.58-8,8s3.58,8,8,8h9.88v23.92h-9.88c-4.42,0-8,3.58-8,8s3.58,8,8,8h9.88v71.54c0,2.37,1.05,4.62,2.87,6.14,12.98,10.85,20.42,26.76,20.42,43.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M562.98,497.26c2.77,0,5.45-1.43,6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93-3.83-2.21-8.72-.9-10.93,2.93l-12.98,22.48c-2.21,3.83-.9,8.72,2.93,10.93h0c1.26.73,2.64,1.07,3.99,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M564.87,420.14h0c-.73-4.36-4.86-7.29-9.22-6.56-4.17.7-8.45,1.06-12.7,1.06h-35.51c-4.42,0-8,3.58-8,8s3.58,8,8,8h35.51c5.14,0,10.31-.43,15.35-1.28,4.36-.73,7.3-4.86,6.56-9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M505.34,235.29h0c.68,0,1.38-.09,2.08-.28,4.27-1.14,6.8-5.53,5.66-9.8-6.45-24.08-27.37-40.73-53.29-42.4-4.4-.28-8.21,3.06-8.5,7.47-.28,4.41,3.06,8.21,7.47,8.5,19.25,1.24,34.15,12.96,38.87,30.58.96,3.58,4.19,5.93,7.72,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M506.36,497.26c2.77,0,5.45-1.43,6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93-3.83-2.21-8.72-.9-10.93,2.93l-12.98,22.48c-2.21,3.83-.9,8.72,2.93,10.93h0c1.26.73,2.64,1.07,3.99,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M527.2,515.9h0c-3.83-2.21-8.72-.9-10.93,2.93l-16.84,29.16c-2.21,3.83-.9,8.72,2.93,10.93,1.26.73,2.64,1.07,3.99,1.07,2.77,0,5.45-1.43,6.94-4l16.83-29.16c2.21-3.83.9-8.72-2.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M493.15,420.59c-1.56-4.75-5.23-8.22-10.05-9.51l-36.67-9.83,25.2-94.05c1.36-5.08-.96-10.27-5.65-12.64-4.69-2.37-10.25-1.16-13.53,2.95h0l-94.93,118.88c-3.12,3.91-4.01,8.87-2.45,13.62,1.56,4.75,5.23,8.22,10.05,9.51l36.67,9.83-25.2,94.05c-1.36,5.07.96,10.27,5.65,12.64,1.6.81,3.31,1.2,4.99,1.2,3.23,0,6.38-1.45,8.54-4.15l94.93-118.88c3.12-3.91,4.01-8.87,2.45-13.62h0ZM476.82,425.96l-78.55,98.36,19.35-72.24c1.01-3.75.49-7.67-1.46-11.04-1.95-3.37-5.08-5.78-8.83-6.78l-35.93-9.63,78.55-98.36-19.35,72.24c-1,3.75-.49,7.67,1.46,11.04,1.95,3.37,5.08,5.78,8.83,6.78l35.93,9.63h0Z"
  }))));
};
export default SvgProbabilitySferics01;